import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import ContactStatement from "./ContactStatement";
import VendorStatement from "./VendorStatement";
// import SubAssetStatement from "./SubAssetStatement";
import { getModuleNamingBySlug } from "../../../lib/Misc";
import { useOrganization } from "../../../lib/context/OrganisationContext";

const StatmentReports = ({ org = false }) => {
  const { organizationData } = useOrganization();

  const tabsKey = [
    {
      name: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer"
      )} Statment`,
      tabName: "customer-statement",
      value: 1,
    },
    {
      name: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor"
      )} Statment`,
      tabName: "vendor-statement",
      value: 2,
    },
    // {
    //   name: `${getModuleNamingBySlug(
    //     organizationData?.organizationData,
    //     "sub-assets",
    //     "Sub Asset"
    //   )} Statment`,
    //   tabName: "sub-asset-statement",
    //   value: 3,
    // },
  ];
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "customer-statement";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;
  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className="!bg-background"
        >
          {activeTab === 1 ? (
            <ContactStatement org={org} />
          ) : activeTab === 2 ? (
            <VendorStatement org={org} />
          ) : (
            <></>
            // <SubAssetStatement org={org} />
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default StatmentReports;
